export default "__VITE_ASSET__Cgn1zfNF__"